const locationTypes = {
	LIST: {
		REQUEST: 'LOCATION_LIST_REQUEST',
		SUCCESS: 'LOCATION_LIST_SUCCESS',
		FAILURE: 'LOCATION_LIST_FAILURE',
		CLEAR: 'LOCATION_LIST_CLEAR',
	},

	NESHAN_POSITION: {
		REQUEST: 'LOCATION_NESHAN_POSITION_REQUEST',
		SUCCESS: 'LOCATION_NESHAN_POSITION_SUCCESS',
		FAILURE: 'LOCATION_NESHAN_POSITION_FAILURE',
		CLEAR: 'LOCATION_NESHAN_POSITION_CLEAR',
	},
	POINT_TO_ADDRESS: {
		REQUEST: 'LOCATION_POINT_TO_ADDRESS_REQUEST',
		SUCCESS: 'LOCATION_POINT_TO_ADDRESS_SUCCESS',
		FAILURE: 'LOCATION_POINT_TO_ADDRESS_FAILURE',
		CLEAR: 'LOCATION_POINT_TO_ADDRESS_CLEAR',
	},
};

export default locationTypes;
